import { Injectable } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CoreModule } from '../core.module';

export const ERROR_MESSAGES: Record<string, (label: string, error?: any) => string> = {
	required: (label: string) => `${label} is required.`,
	minlength: (label: string, error: any) => `${label} must be at least ${error.requiredLength} characters.`,
	maxlength: (label: string, error: any) => `${label} must be ${error.requiredLength} characters or less`,
	min: (label: string, error: any) => `${label} must be at least ${error.min}`,
	max: (label: string, error: any) => `${label} must be ${error.max} or less`,
};

@Injectable({
	providedIn: CoreModule,
})
export class FormErrorsService {
	getFieldErrorMessages(field: NgControl, label: string) {
		if (!Object.keys(field.errors ?? {}).length) {
			return [];
		}
		const errors = Object.keys(field.errors).map((errorType) => {
			const error = field.errors[errorType];
			const errorFn = ERROR_MESSAGES[errorType];
			if (!errorFn || typeof errorFn !== 'function') {
				return 'Invalid field';
			}
			return errorFn(label, error);
		});
		return errors;
	}
}
